/**
 * This directive allows us to preselect ng-options in an angularized select box with booleans instead of strings.
 * A plain Javascript implementation is provided by the official AngularJS documentation at the bottom of
 * https://code.angularjs.org/1.5.3/docs/api/ng/directive/select
 */

export class ConvertToBooleanDirective implements angular.IDirective {
    public require: string = 'ngModel';

    public link(scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) {
        let storeAsNumber: boolean = false;

        ngModel.$parsers.push((val: any) => {
            let isTrue = this.lodash.lowerCase(val) === 'true';

            /* If we had a 0 or 1 come in, we should send a 0 or 1 back out */
            if (storeAsNumber) {
                return isTrue ? 1 : 0;
            }

            return isTrue;
        });

        ngModel.$formatters.push((val: any) => {
            /* Handle the case where val is 0 or 1 instead of false or true */
            if (typeof val === 'number') {
                val = val === 0 ? 'false' : 'true';

                storeAsNumber = true;
            }

            return '' + this.lodash.lowerCase(val);
        });
    }

    constructor(
        private lodash: _.LoDashStatic
    ) {
    }

    public static Factory() {
        let directive = (lodash) => {
            return new ConvertToBooleanDirective(lodash);
        };

        directive['$inject'] = ['lodash'];

        return directive;
    }
}
